import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent  implements OnInit {

  ngOnInit() {}

  @Input() title = 'Confirmation';
  @Input() message = 'Are you sure you want to do this action?';
  @Input() yesText = 'Yes';
  @Input() noText = 'No';
  // 'danger' turns the confirm button red for destructive or ending actions
  @Input() yesVariant: 'primary' | 'danger' = 'primary';
  // Taller buttons and an underlined cancel action, easier to tap and to recognise for older users
  @Input() large = false;

  constructor(private modalCtrl: ModalController) {}

  dismiss(result: boolean) {
    this.modalCtrl.dismiss(result);
  }

}
